<template>
  <div
    style="cursor: pointer; padding: 10px;"
    class="text-center py-5 ma-1 fill-height"
    :class="$vuetify.theme.dark == true ? 'darkModeCard' : 'whiteTheme'"
  >
    <p class="google-font mb-0" style="font-weight: 350;font-size:180%">
      <b>Profil</b>
    </p>
    <v-divider></v-divider><br />
    <p class="mt-3 mb-0 google-font mb-0" style="font-size:130%">
     Username: {{ currentUser?currentUser.niceName:'' }}
    </p>
    <p class="mt-3 mb-0 google-font mb-0" style="font-size:130%">
     E-Mail: {{ currentUser?currentUser.eMail:'' }}
    </p><br>

    <p>
      <v-btn
        rounded
        block
        color="red"
        style="text-transform: capitalize;border-radius:5px;text-transform: capitalize;"
        large
        dark
        @click="logout()"
        >Logout</v-btn
      >
    </p>
  </div>
</template>

<script>
import router from "@/router/index.js";
import {
    mapGetters,
    mapActions
} from "vuex";
export default {
  inject: ["theme"],
  name: "ProfilCard",
  computed: {
        ...mapGetters(["currentUser"])
    },
  methods: {
    ...mapActions(["signOut"]),
    logout() {
      this.signOut().then(() => {
        router.push("/");
      });
    },
  }
};
</script>
